module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', _vm._l((_vm.utils.getSectionNamesBySorted(_vm.layoutFooterConfig.sections)), function(item, key) {
    return _c('PageSection', {
      key: key,
      attrs: {
        "section-name": item,
        "config": _vm.layoutFooterConfig.sections,
        "data-set": _vm.layoutDataSet
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ca166ff","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/footer/Footer.vue
// module id = 690bfdbab71a8e2cea91
// module chunks = 18